function dlPush(ev, data) {
  window.track_event[ev] = data;
  window.dataLayer.push({...data, event: ev});
}

export const pushDataLayerEventCache = () => {
  const cookieData = evite.cookie('x-evite-gtmcache');
  if (!cookieData) return;
  // Remove the signing data from the end of the cookie
  let data = cookieData.split(':').slice(0, -2).join(':');
  // Convert backslashed quotes and converted commas and remove the leading " from the data
  data = data.replace(/\\054/g, ',').replace(/\\"/g, '"').slice(1);
  const eventCache = JSON.parse(data);
  for (const [key, value] of Object.entries(eventCache)) {
    dlPush(key, value);
  }
  // Different environments have different domains set for this cookie.  Try them all
  const origDomain = window.location.hostname;
  for (const domain of [
    undefined,
    origDomain,
    `.${origDomain}`,
    `.${origDomain.split('.').slice(1).join('.')}`,
  ])
    evite.cookie('x-evite-gtmcache', null, {path: '/', domain}); // Delete the cookie
};

export const trackEventId = (eventId) => {
  // biome-ignore lint/style/useNamingConvention: existing error
  window.dataLayer.push({event_id: eventId});
};

export const pushDataLayerEcommerceObject = (ecommerce) => {
  const ecommerceObject = {
    event: 'greeting_card_purchase',
    ...ecommerce,
  };

  window.dataLayer.push(ecommerceObject);
};
